import { render, staticRenderFns } from "./EssentialNeedsCalculator.vue?vue&type=template&id=8cc4cd2a&scoped=true&"
import script from "./EssentialNeedsCalculator.vue?vue&type=script&lang=js&"
export * from "./EssentialNeedsCalculator.vue?vue&type=script&lang=js&"
import style0 from "./EssentialNeedsCalculator.vue?vue&type=style&index=0&id=8cc4cd2a&lang=scss&scoped=true&"
import style1 from "./EssentialNeedsCalculator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc4cd2a",
  null
  
)

export default component.exports